// extracted by mini-css-extract-plugin
module.exports = {"select":"select_select__D3i2C","open":"select_open__qC73L","invalid":"select_invalid__v9rQP"};